module.exports = __webpack_public_path__ + "img/team.a820666e.jpg";